import { fetchDeviceAnalytics } from '../actions/adminActions';

export interface LatestReading {
  value: number;
  timestamp: string;
}

export interface DeviceAnalytics {
  device_key: string;
  version: string;
  organization: {
    id: number;
    name: string | null;
  };
  location: {
    latitude: number | null;
    longitude: number | null;
  } | null;
  battery: LatestReading | null;
  liquid_level: LatestReading | null;
  signal: LatestReading | null;
  last_reading_at: string | null;
}

const initialState = {
  deviceAnalytics: [] as DeviceAnalytics[],
  versions: [] as string[],
};

export const admin = (state = initialState, action) => {
  switch (action.type) {
    case fetchDeviceAnalytics.success:
      return {
        ...state,
        deviceAnalytics: action.payload.devices,
        versions: action.payload.versions,
      };
    default:
      return state;
  }
};
